import { Link } from "react-router-dom";
import { ArrowRight, Package } from "lucide-react";

interface PackageCalloutProps {
  packageId: string;
  packageName: string;
  blurb: string;
}

export const PackageCallout = ({ packageId, packageName, blurb }: PackageCalloutProps) => {
  return (
    <section className="py-8 bg-background">
      <div className="container mx-auto px-4">
        <Link
          to={`/packages#${packageId}`}
          className="block group rounded-lg border border-primary/30 bg-card hover:border-primary transition-colors p-6 md:p-7"
        >
          <div className="flex items-start gap-4">
            <div className="hidden sm:flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary/10 text-primary">
              <Package className="h-5 w-5" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-xs uppercase tracking-wider text-primary font-semibold mb-1">
                Available as a package
              </div>
              <h2 className="text-lg md:text-xl font-semibold text-foreground mb-1">
                {packageName}
              </h2>
              <p className="text-sm md:text-base text-muted-foreground">{blurb}</p>
            </div>
            <div className="hidden md:flex items-center text-primary shrink-0 self-center gap-1 text-sm font-medium group-hover:gap-2 transition-all">
              View package <ArrowRight className="h-4 w-4" />
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
};